<div class="grid">
	<div class="col-12">
		<mat-card class="mat-elevation-z0 px-5 pb-3 h-full flex flex-col" *ngIf="Project !== null; else loading">
            <mat-card-title class="flex justify-content-between mt-1">
                <div class="flex items-center">
                        <button mat-stroked-button color="primary" class="mr-3 font-bold" routerLink="/projectoffice/assingments">
                            <i class="fa fa-arrow-left"></i> {{ 'general.back' | translate }}
                        </button>
                        <div class="text-xl font-bold">{{ 'txProjectOffice.assignment' | translate }}</div>
					</div>
                <span *ngIf="reports$ | async as reports">
                    <button mat-icon-button class="tx-pdf-button" color="accent" type="button"
                            [disabled]="loadingReport" [matMenuTriggerFor]="reportMenu">
                        <fa-icon *ngIf="!loadingReport" icon="file-pdf" class="large-icon"></fa-icon>
                        <fa-icon *ngIf="loadingReport" icon="spinner" class="large-icon" [spin]="true"
                                 disabled></fa-icon>
                    </button>
                    <mat-menu #reportMenu="matMenu">
                        <button *ngFor="let report of reports" (click)="downloadReport(report)" mat-menu-item>
                            {{ report.report_name }}
                        </button>
                    </mat-menu>
                </span>
				</mat-card-title>
			<mat-card-content>
				<ng-container *ngIf="ProjectForm">
					<form [formGroup]="ProjectForm">
						<div class="project-form-grid">
							<div class="grid-left-column">
                                    <!-- Project number and name row -->
                                    <div class="form-row">
                                        <mat-form-field appearance="outline" class="project-number">
                                            <mat-label>{{ 'txProjectOffice.number' | translate }}</mat-label>
                                            <input matInput formControlName="project_number" required />
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="project-name">
                                            <mat-label>{{ 'txProjectOffice.description' | translate }}</mat-label>
                                            <input matInput formControlName="project_name" [matTooltip]="project_name" required />
                                        </mat-form-field>
                                    </div>
                                    
                                    <!-- Select fields row -->
                                    <div class="form-row selects-row">
                                        <mat-form-field *ngIf="Kst$ | async as Kst" appearance="outline">
                                            <mat-label>{{ 'txProjectOffice.costcenter' | translate }}</mat-label>
                                            <mat-select formControlName="cost_id">
                                                <mat-option *ngFor="let center of Kst" [value]="center.id">
                                                    {{ center.bezeichnung }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ 'txProjectOffice.status' | translate }}</mat-label>
                                            <mat-select formControlName="project_state">
                                                <mat-option *ngFor="let state of ProjectStates" [value]="state.value">
                                                    {{ state.description }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline">
                                            <mat-label>
                                                <span [class.text-danger]="ProjectForm.value.unproductive === 1">{{ 'txProjectOffice.type' | translate }}</span>
                                            </mat-label>
                                            <mat-select formControlName="unproductive" [class.test-danger]="ProjectForm.value.unproductive === 1">
                                                <mat-option [value]="0">Produktiv</mat-option>
                                                <mat-option [value]="1" class="text-danger">Unproduktiv</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    
                                    <!-- Description textarea -->
                                    <div class="form-row">
                                        <mat-form-field appearance="outline" class="full-height">
                                            <mat-label>{{ 'txProjectOffice.description' | translate }}</mat-label>
                                            <textarea matInput rows="10" [matTextareaAutosize]="true" formControlName="description"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
							<div class="grid-right-column">
								<mat-form-field appearance="outline">
									<mat-label>{{ 'txProjectOffice.create_date' | translate }}</mat-label>
									<input matInput formControlName="creation_date" [matDatepicker]="pickerCreation" />
									<mat-datepicker-toggle matSuffix [for]="pickerCreation"></mat-datepicker-toggle>
									<mat-datepicker #pickerCreation></mat-datepicker>
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>{{ 'txProjectOffice.is_time' | translate }}</mat-label>
									<div class="display-flex flex-justify-content-space-between">
										<input matInput type="text" formControlName="calculated_time" />
										<span *ngIf="!!Filter.to && !!Filter.from && !!FilterProject" class="filter-active-input">{{
											FilterProject.calculated_time
										}}</span>
									</div>
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>{{ 'txProjectOffice.end_planed' | translate }}</mat-label>
									<input matInput formControlName="target_date" [matDatepicker]="pickerEnd" />
									<mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
									<mat-datepicker #pickerEnd></mat-datepicker>
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>{{ 'txProjectOffice.should_time' | translate }}</mat-label>
									<input
										matInput
										mask="000:00"
										[showMaskTyped]="true"
										[dropSpecialCharacters]="false"
										type="text"
										formControlName="target_time" />
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>{{ 'txProjectOffice.should_amount' | translate }}</mat-label>
									<input matInput type="number" step="0.1" formControlName="target_quantity" />
								</mat-form-field>
							</div>
						</div>
					</form>
				</ng-container>
			</mat-card-content>
		</mat-card>
	</div>
    <div class="col-12">
        <mat-card class="mat-elevation-z0 px-5 pb-3 h-full flex flex-col">
            <mat-card-content>
                <div class="display-flex flex-ml-1">
                    <div class="display-flex flex-align-items-center">
                        <button mat-raised-button color="basic" [disabled]="!ProjectForm.dirty" (click)="resetForm(Project)">
                            {{ 'general.abort' | translate }}
                        </button>
                    </div>
                    <div class="flex-grow-1 display-flex flex-justify-content-center flex-align-items-center">
                        <div *ngIf="isFiltering()" class="display-flex">
                            <!--<div>
                                <div class="display-flex p-1" [ngClass]="{ 'filter-active': !!Filter.from }">
                                    <h5 class="no-margin">Von: {{ Filter.from | date:'dd.MM.yyyy' }}</h5>
                                </div>
                                <mat-calendar (selectedChange)="Filter.from = $event">
                                </mat-calendar>
                            </div>
                            <div class="ml-1">
                                <div class="display-flex p-1" [ngClass]="{ 'filter-active': !!Filter.to }">
                                    <h5 class="no-margin">Bis: {{ Filter.to | date:'dd.MM.yyyy' }}</h5>
                                </div>
                                <mat-calendar [minDate]="Filter.from" (selectedChange)="Filter.to = $event; startFilter()">
                                </mat-calendar>
                            </div>-->
                        </div>
                    </div>
                    <div class="display-flex flex-align-items-center">
                        <mat-form-field *ngIf="Project.project_id" appearance="standard" class="mr-4 filter-select-field">
                            <mat-label>{{ 'txProjectOffice.daterange_filter' | translate }}</mat-label>
                            <mat-date-range-input [rangePicker]="filterPicker" (click)="filterPicker.open()">
                                <input matStartDate [(ngModel)]="Filter.from" placeholder="Startdatum" disabled />
                                <input
                                        matEndDate
                                        [(ngModel)]="Filter.to"
                                        placeholder="Enddatum"
                                        (dateChange)="startFilter()"
                                        disabled />
                            </mat-date-range-input>
                            <mat-datepicker-toggle *ngIf="!isFiltering()" matSuffix [for]="filterPicker" [disabled]="false">
                            </mat-datepicker-toggle>
                            <button
                                    mat-icon-button
                                    color="warn"
                                    *ngIf="isFiltering()"
                                    matSuffix
                                    (click)="Filter.from = null; Filter.to = null; FilterProject = null; FilterBookings = null">
                                <fa-icon icon="times"></fa-icon>
                            </button>
                            <mat-date-range-picker #filterPicker [disabled]="false"></mat-date-range-picker>
                        </mat-form-field>
                        <!--<mat-slide-toggle class="mr-1" color="primary" [(ngModel)]="isFiltering">
                            Zeitraum Filtern
                        </mat-slide-toggle>-->
                        <button
                                (click)="saveOrCreate($event, Project, Project.project_id === 0)"
                                mat-raised-button
                                color="primary"
                                [disabled]="ProjectForm.invalid || ProjectForm.untouched">
                            {{ 'general.save' | translate }}
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
	<div class="col-12">
        <mat-accordion
                *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('p1')"
                    (closed)="onTabClose('p1')"
                    [ngClass]="{ 'filter-active': !!Filter.to && !!Filter.from }"
                    [expanded]="TabStates?.p1 == null || TabStates?.p1 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title class="!mr-0">
                        <div class="flex items-center justify-between w-full">
                            <div class="flex items-center space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.p1 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txProjectOffice.task' | translate }}
                                </div>
                            </div>
                            <div class="flex items-center">
                                <button mat-stroked-button class="mr-1" type="button" (click)="Refresh(Project); $event.stopPropagation()">
                                    <fa-icon icon="sync"></fa-icon>
                                    {{ 'txProjectOffice.refresh' | translate }}
                                </button>
                                <button mat-stroked-button type="button" (click)="openDialog(Project); $event.stopPropagation()">
                                    <fa-icon icon="plus-circle"></fa-icon>
                                    {{ 'txProjectOffice.add' | translate }}
                                </button>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap border-1 rounded">
                        <div class="table-scroll" style="--tscroll-min: 1100px">
                        <table class="full-width min-w-[700px]" mat-table [dataSource]="WorkstepDatasource" matSort>
                            <ng-container matColumnDef="workstep_id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.id' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.workstep_project_id }}</td>
                            </ng-container>
                            <ng-container matColumnDef="workstep_name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.description_alt' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.workstep_name }}</td>
                            </ng-container>
                            <ng-container matColumnDef="sum_quantity">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.is_amount' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.sum_quantity }}</td>
                            </ng-container>
                            <ng-container matColumnDef="calculated_time">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.is_time' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.calculated_time }}</td>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let row" class="text-center">
                                    <div>
                                        <button
                                                mat-icon-button
                                                type="button"
                                                [matMenuTriggerFor]="menu"
                                                aria-label="Example icon-button with a menu">
                                            <fa-icon icon="ellipsis-v"></fa-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <div
                                                    mat-menu-item
                                                    class="no-margin"
                                                    [matTooltipDisabled]="row.calculated_time === '00:00'"
                                                    matTooltip="{{ 'txProjectOffice.has_booked_time' | translate }}">
                                                <button
                                                        mat-icon-button
                                                        type="button"
                                                        [disabled]="row.calculated_time !== '00:00'"
                                                        (click)="deleteWorkstep(row)">
                                                    <fa-icon icon="minus-circle"></fa-icon>
                                                    <span class="text-danger">&nbsp;{{ 'txProjectOffice.delete' | translate }}</span>
                                                </button>
                                            </div>
                                        </mat-menu>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        </div>
                    </div>
                    <mat-paginator #workstepsPaginator [pageSizeOptions]="[5, 15, 25, 50, 100]" [pageSize]="15" showFirstLastButtons></mat-paginator>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
	</div>
	<div class="col-12 mb-4" *ngIf="Project.project_id > 0">
        <mat-accordion
                *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('p2')"
                    (closed)="onTabClose('p2')"
                    [ngClass]="{ 'filter-active': !!Filter.to && !!Filter.from }"
                    [expanded]="TabStates?.p2 == null || TabStates?.p2 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title class="!mr-0">
                        <div class="flex items-center justify-between w-full">
                            <div class="flex items-center space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.p2 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txProjectOffice.bookings' | translate }}
                                </div>
                            </div>
                            <div class="flex items-center">
                                <button mat-stroked-button type="button" (click)="loadAllBookings(Project.project_id); $event.stopPropagation()">
                                    <fa-icon icon="cloud-download-alt"></fa-icon>
                                    <span> {{ 'txProjectOffice.load_all' | translate }}</span>
                                </button>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                    <ng-container *ngIf="Project.project_id > 0">
                        <div *ngIf="Bookings !== null; else loading">
                            <div class="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap border-1 rounded">
                                <div class="table-scroll" style="--tscroll-min: 1100px">
                                <table class="full-width min-w-[700px]" mat-table [dataSource]="BookingsDatasource" matSort #bookingsSort="matSort">
                                    <ng-container matColumnDef="id">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.id' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="employee_name">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.employees' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">
                                            <a [routerLink]="['/kalender', { id: row.employee_id, date: (row.datum | date: 'yyyy-MM-dd') }]">{{row.employee_name}}</a>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="workstep_name">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.task' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.workstep_name }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="datum">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.day' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.datum | date: 'dd.MM.yyyy' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="begin_end_time">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base">{{ 'txProjectOffice.timerange' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.begin_time | date: 'HH:mm' }} - {{ row.end_time | date: 'HH:mm' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="calculated_time">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base text-right">{{ 'txProjectOffice.time' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.calculated_time }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="quantity">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-weight-bold text-base text-right">{{ 'txProjectOffice.amount' | translate }}</th>
                                        <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBookings"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBookings;"></tr>
                                </table>
                                </div>
                            </div>
                            <mat-paginator #bookingsPaginator [pageSizeOptions]="[5, 15, 25, 50, 100]" [pageSize]="15" showFirstLastButtons></mat-paginator>
                        </div>
                    </ng-container>
            </mat-expansion-panel>
        </mat-accordion>
	</div>
</div>

<ng-template #loading>
	<section class="widget display-flex flex-justify-content-center">
        <ng-container *ngIf="!initDone">
		    <mat-spinner></mat-spinner>
        </ng-container>
        <ng-container *ngIf="initDone">
            <h5 class="text-center">{{ 'general.no_data' | translate }}</h5>
        </ng-container>
	</section>
</ng-template>
